// extracted by css-extract-rspack-plugin
export default {"list":"List_list__bSnBD"};